import React from "react";
import { Button, Modal } from "@payping/web-components";
import { useAppDispatch, useAppSelector } from "@/utils/redux";
import { dashboardReduxReducerActions } from "@/redux/actions/dashboard";
import { useAppTranslation } from "@/utils/useAppTranslation";
import { Link } from "react-router-dom";
import { webConstants } from "@payping/utils/platformConstants";
import { Trans } from "@payping/utils/localeUtils";
import { safeJoinPath } from "@payping/utils/string";

const docUrl = "https://payping.io/help/fa/category/1r4l656/";

const DashboardToolsUpgradeUserPlanToProModal: React.FC = () => {
  const showModal = useAppSelector((state) => state.dashboard.upgradeUserPlanToPro);
  const dispatch = useAppDispatch();

  const { t } = useAppTranslation();

  const services = {
    invoice: {
      title: t("dashboardTools.upgradeUserPlanToProModal.services.invoice"),
      helpUrl: safeJoinPath(webConstants.HELP_URL, "/fa/faktor-anlainarah-faktor-rsmi/"),
    },
  };

  const handleCloseModal = React.useCallback(() => {
    dispatch(dashboardReduxReducerActions.hideUpgradeUserPlanToProModal());
  }, [dispatch]);

  return (
    <Modal
      open={showModal.showModal}
      onCancel={handleCloseModal}
      centered
      closable
      title={t("dashboardTools.upgradeUserPlanToProModal.title")}
      footer={
        <Link className="w-100" to={webConstants.DashboardRoutes.user.upgrade} onClick={() => handleCloseModal()}>
          <Button className="w-100" type="primary">
            {t("dashboardTools.upgradeUserPlanToProModal.callToAction")}
          </Button>
        </Link>
      }
    >
      <p className="mb-2">
        {!showModal.service ? (
          ""
        ) : (
          <Trans
            i18nKey={"dashboardTools.upgradeUserPlanToProModal.content"}
            values={{
              serviceName: services[showModal.service].title,
            }}
            components={{
              span: <span />,
              a: <a href={services[showModal.service].helpUrl} target="_blank" rel="noreferrer" />,
              b: <a href={docUrl} target="_blank" rel="noreferrer" />,
            }}
          />
        )}
      </p>
    </Modal>
  );
};

export default DashboardToolsUpgradeUserPlanToProModal;
